__turbopack_context__.v({
  "blok-big-title": "CartImage-module__C0cC2G__blok-big-title",
  "blok-subtitle": "CartImage-module__C0cC2G__blok-subtitle",
  "blok-title": "CartImage-module__C0cC2G__blok-title",
  "cart-image": "CartImage-module__C0cC2G__cart-image",
});
